import {
    COM_AREA_LIST, COM_AREA_LIST_SUCCESS, COM_AREA_LIST_ERROR,
    COM_AREA_PAGE_SET, COM_AREA_SEARCH_CHANGE,
    COM_AREA_ADD_MODAL_SET, COM_AREA_ADD_CHANGE,
    COM_AREA_ADD, COM_AREA_ADD_SUCCESS, COM_AREA_ADD_ERROR,
    COM_AREA_EDIT_MODAL_SET, COM_AREA_EDIT_SET_DATA,
    COM_AREA_UPDATE, COM_AREA_UPDATE_SUCCESS, COM_AREA_UPDATE_ERROR,
    COM_AREA_CANCEL_MODAL_SET, COM_AREA_CANCEL_SET_DATA,
} from '../../actions';

const INIT_STATE = {
    loading: false,
    list: { page: { current: 1, rows: 10 }, data: [], total_pages: 0, total_item: 0 },
    search: { data: { code: '', name: '' } },
    add: { data: { code: '', name: '', description: '' }, modal: false, loading: false, message: '' },
    edit: { data: null, modal: false, loading: false, message: '' },
    cancel: { data: null, modal: false },
    error: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case COM_AREA_LIST: return { ...state, loading: true };
        case COM_AREA_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case COM_AREA_LIST_ERROR: return { ...state, loading: false, error: true };
        case COM_AREA_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case COM_AREA_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };

        case COM_AREA_ADD_MODAL_SET: return { ...state, add: { ...state.add, modal: action.payload } };
        case COM_AREA_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, ...action.payload } } };
        case COM_AREA_ADD: return { ...state, add: { ...state.add, loading: true } };
        case COM_AREA_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, modal: false, message: action.payload.message, data: { code: '', name: '', description: '' } } };
        case COM_AREA_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload } };

        case COM_AREA_EDIT_MODAL_SET: return { ...state, edit: { ...state.edit, modal: action.payload } };
        case COM_AREA_EDIT_SET_DATA: return { ...state, edit: { ...state.edit, data: action.payload } };
        case COM_AREA_UPDATE: return { ...state, edit: { ...state.edit, loading: true } };
        case COM_AREA_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, loading: false, modal: false, message: action.payload.message } };
        case COM_AREA_UPDATE_ERROR: return { ...state, edit: { ...state.edit, loading: false, message: action.payload } };

        case COM_AREA_CANCEL_MODAL_SET: return { ...state, cancel: { ...state.cancel, modal: action.payload } };
        case COM_AREA_CANCEL_SET_DATA: return { ...state, cancel: { ...state.cancel, data: action.payload } };

        default: return { ...state };
    }
};
